import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Coffee, ShieldCheck, Users, Globe } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const activities = [{
  title: 'Quality Control',
  description: 'Ensuring all exported coffee meets international quality standards.',
  icon: ShieldCheck
}, {
  title: 'Export Regulation',
  description: 'Licensing and regulating coffee exporters and processors.',
  icon: Globe
}, {
  title: 'Farmer Support',
  description: 'Providing extension services and distributing coffee seedlings.',
  icon: Users
}, {
  title: 'Brand Promotion',
  description: 'Promoting Ugandan coffee brands in international markets.',
  icon: Coffee
}];
export function UcdaPage() {
  return <>
      <Header data-id="element-1632" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1633">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1634">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=1600&h=600&fit=crop")'
        }} data-id="element-1635"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1636"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1637">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1638">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1639">
                <Home className="w-4 h-4 mr-1" data-id="element-1640" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1641" />
              <span data-id="element-1642">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1643" />
              <span className="text-white font-medium" data-id="element-1644">UCDA</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1645">UCDA</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-1646">
              Uganda Coffee Development Authority.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-1647">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 mb-12" data-id="element-1648">
            <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1649">
              Our Mandate
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-1650">
              To promote and oversee the coffee industry by supporting research,
              promoting production, controlling the quality, and improving the
              marketing of coffee in order to optimize foreign exchange earnings
              for the country and payments to the farmers.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-8" data-id="element-1651">
            Key Activities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1652">
            {activities.map((activity, index) => {
            const Icon = activity.icon;
            return <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-1653">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-4" data-id="element-1654">
                    <Icon className="w-6 h-6" data-id="element-1655" />
                  </div>
                  <h3 className="text-lg font-bold text-uganda-black mb-2" data-id="element-1656">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-1657">
                    {activity.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-1658" />
    </>;
}